// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/mtm_model.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's mtm_model.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/mtm_model.proto.
 */
export const file_devtool_emodel_v1_mtm_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_type_date]);

/**
 * TickerGroup groups positions evaluated against the same market curve ticker.
 *
 * @generated from message devtool.emodel.v1.TickerGroup
 */
export type TickerGroup = Message<"devtool.emodel.v1.TickerGroup"> & {
  /**
   * Market curve ticker (e.g., "ENECHAIN_TOKYO_BASE_FY", "EEX_TOKYO_BASE_MONTH")
   *
   * @generated from field: string ticker = 1;
   */
  ticker: string;

  /**
   * Positions to evaluate against this ticker's forward curve
   *
   * @generated from field: repeated devtool.emodel.v1.MTMPosition positions = 2;
   */
  positions: MTMPosition[];

  /**
   * Confirmed market prices for this ticker (daily granularity).
   * Each market price is automatically associated with the nearest forward curve
   * data point (grouped by "before next data point date" rule).
   *
   * @generated from field: repeated devtool.emodel.v1.MarketPrice market_prices = 3;
   */
  marketPrices: MarketPrice[];
};

/**
 * Describes the message devtool.emodel.v1.TickerGroup.
 * Use `create(TickerGroupSchema)` to create a new message.
 */
export const TickerGroupSchema: GenMessage<TickerGroup> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_mtm_model, 0);

/**
 * MTMPosition represents a single position for MTM evaluation.
 *
 * @generated from message devtool.emodel.v1.MTMPosition
 */
export type MTMPosition = Message<"devtool.emodel.v1.MTMPosition"> & {
  /**
   * Unique identifier for this position
   *
   * @generated from field: string position_id = 1;
   */
  positionId: string;

  /**
   * Delivery period start (curve lookup range start). Also used to expand
   * daily entries when delivery_points is empty.
   *
   * @generated from field: google.type.Date from = 2;
   */
  from?: Date;

  /**
   * Delivery period end (curve lookup range end; if omitted, same as from).
   * Also used to expand daily entries when delivery_points is empty.
   *
   * @generated from field: optional google.type.Date to = 3;
   */
  to?: Date;

  /**
   * Volume per delivery point, expressed in the unit aligned with the forward
   * curve and contract_price (e.g. kWh for power, barrel for oil).
   * Positive = buy, negative = sell.
   *
   * @generated from field: double volume = 4;
   */
  volume: number;

  /**
   * Fixed price component of the contract (per unit)
   *
   * @generated from field: double contract_price = 5;
   */
  contractPrice: number;

  /**
   * Floating index ticker (e.g., "JERAGM_Wholesale_TBL_JKM_FY26").
   * If set, the floating index curve price is added to contract_price.
   *
   * @generated from field: optional string floating_ticker = 6;
   */
  floatingTicker?: string;

  /**
   * Whether this position involves physical delivery settlement (品代).
   * true  = physical delivery (e.g., BG) — one settlement cashflow is emitted
   *         per delivery month (contract × V_month × -sign), and delivered days
   *         contribute 0 to realized_pnl (the P&L is absorbed into the CF).
   * false = financial settlement (e.g., JEPX, Swap/CFD) — no settlement cashflows;
   *         delivered days contribute (spot - contract) × V × sign as realized_pnl.
   *
   * @generated from field: bool physically_settled = 7;
   */
  physicallySettled: boolean;

  /**
   * The date up to which delivery has been settled (payment completed).
   * All delivery days on or before this date are considered settled, and their
   * corresponding settlement cashflows are excluded from MTM.
   * Mirrors ePosition's DealTransaction.SettledUntil.
   * If omitted, no days are considered settled.
   *
   * @generated from field: optional google.type.Date settled_until = 8;
   */
  settledUntil?: Date;

  /**
   * Explicit list of delivery points (dates on which `volume` is delivered).
   * When non-empty, the MTM engine evaluates these dates exactly — `from`/`to`
   * are ignored for daily expansion (they may still be used for display).
   * Use this for contracts whose delivery schedule is not a uniform daily
   * sequence over [from, to], e.g.:
   *   - electricity peak contracts (business days only, 8:00-20:00)
   *   - monthly oil swaps (one delivery per month)
   *   - irregular delivery schedules
   * When empty, the engine expands [from, to] into calendar days uniformly
   * with `volume` applied to every day. This is the default for baseload power.
   *
   * @generated from field: repeated google.type.Date delivery_points = 9;
   */
  deliveryPoints: Date[];
};

/**
 * Describes the message devtool.emodel.v1.MTMPosition.
 * Use `create(MTMPositionSchema)` to create a new message.
 */
export const MTMPositionSchema: GenMessage<MTMPosition> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_mtm_model, 1);

/**
 * MarketPrice represents a confirmed market price for a specific date.
 * Used for realized P&L and P_unrealized computation.
 *
 * @generated from message devtool.emodel.v1.MarketPrice
 */
export type MarketPrice = Message<"devtool.emodel.v1.MarketPrice"> & {
  /**
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * @generated from field: double price = 2;
   */
  price: number;
};

/**
 * Describes the message devtool.emodel.v1.MarketPrice.
 * Use `create(MarketPriceSchema)` to create a new message.
 */
export const MarketPriceSchema: GenMessage<MarketPrice> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_mtm_model, 2);

/**
 * MTMTickerGroupResult holds results for all positions under one market ticker.
 *
 * @generated from message devtool.emodel.v1.MTMTickerGroupResult
 */
export type MTMTickerGroupResult = Message<"devtool.emodel.v1.MTMTickerGroupResult"> & {
  /**
   * @generated from field: string ticker = 1;
   */
  ticker: string;

  /**
   * @generated from field: repeated devtool.emodel.v1.MTMPositionResult position_results = 2;
   */
  positionResults: MTMPositionResult[];
};

/**
 * Describes the message devtool.emodel.v1.MTMTickerGroupResult.
 * Use `create(MTMTickerGroupResultSchema)` to create a new message.
 */
export const MTMTickerGroupResultSchema: GenMessage<MTMTickerGroupResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_mtm_model, 3);

/**
 * MTMPositionResult holds the value decomposition for one position.
 *
 * @generated from message devtool.emodel.v1.MTMPositionResult
 */
export type MTMPositionResult = Message<"devtool.emodel.v1.MTMPositionResult"> & {
  /**
   * @generated from field: string position_id = 1;
   */
  positionId: string;

  /**
   * Per-date-point breakdown (daily realized / unrealized values)
   *
   * @generated from field: repeated devtool.emodel.v1.MTMDateResult date_results = 2;
   */
  dateResults: MTMDateResult[];

  /**
   * Per-month settlement cashflows (only present for physically_settled positions)
   *
   * @generated from field: repeated devtool.emodel.v1.SettlementCashflow settlement_cashflows = 7;
   */
  settlementCashflows: SettlementCashflow[];

  /**
   * Totals across all date points + settlement cashflows
   *
   * @generated from field: double mtm_total = 3;
   */
  mtmTotal: number;

  /**
   * @generated from field: double realized_pnl_total = 4;
   */
  realizedPnlTotal: number;

  /**
   * @generated from field: double unrealized_delivery_value_total = 5;
   */
  unrealizedDeliveryValueTotal: number;

  /**
   * Sum of all settlement cashflow amounts (品代). Matches the sum of
   * settlement_cashflows[].amount.
   *
   * @generated from field: double settlement_cashflows_total = 6;
   */
  settlementCashflowsTotal: number;
};

/**
 * Describes the message devtool.emodel.v1.MTMPositionResult.
 * Use `create(MTMPositionResultSchema)` to create a new message.
 */
export const MTMPositionResultSchema: GenMessage<MTMPositionResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_mtm_model, 4);

/**
 * MTMDateResult holds the value decomposition for a single delivery day.
 *
 * @generated from message devtool.emodel.v1.MTMDateResult
 */
export type MTMDateResult = Message<"devtool.emodel.v1.MTMDateResult"> & {
  /**
   * The delivery day
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * Whether this day has a confirmed market price (= is delivered)
   *
   * @generated from field: bool is_realized = 2;
   */
  isRealized: boolean;

  /**
   * Display-only effective forward price for this day:
   *   - undelivered day: P_unrealized for the day's curve bucket
   *   - delivered day: the raw forward curve price (informational)
   *
   * @generated from field: double forward_price = 3;
   */
  forwardPrice: number;

  /**
   * Resolved contract price (fixed + floating if applicable)
   *
   * @generated from field: double contract_price = 4;
   */
  contractPrice: number;

  /**
   * Confirmed market price (only meaningful for delivered days)
   *
   * @generated from field: double market_price = 5;
   */
  marketPrice: number;

  /**
   * Volume in kWh for this date point
   *
   * @generated from field: double volume_kwh = 6;
   */
  volumeKwh: number;

  /**
   * Value decomposition (daily). Always 0 for BG delivered days
   * (their P&L is absorbed into the monthly settlement cashflow).
   *
   * @generated from field: double realized_pnl = 7;
   */
  realizedPnl: number;

  /**
   * @generated from field: double unrealized_delivery_value = 8;
   */
  unrealizedDeliveryValue: number;
};

/**
 * Describes the message devtool.emodel.v1.MTMDateResult.
 * Use `create(MTMDateResultSchema)` to create a new message.
 */
export const MTMDateResultSchema: GenMessage<MTMDateResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_mtm_model, 5);

/**
 * SettlementCashflow represents a single contract settlement cashflow (品代).
 * Under method C, one cashflow is emitted per delivery month.
 *
 * @generated from message devtool.emodel.v1.SettlementCashflow
 */
export type SettlementCashflow = Message<"devtool.emodel.v1.SettlementCashflow"> & {
  /**
   * First day of the delivery month this cashflow settles
   *
   * @generated from field: google.type.Date delivery_month = 1;
   */
  deliveryMonth?: Date;

  /**
   * Cashflow amount = P_contract * V_month * (-sign)
   *
   * @generated from field: double amount = 2;
   */
  amount: number;
};

/**
 * Describes the message devtool.emodel.v1.SettlementCashflow.
 * Use `create(SettlementCashflowSchema)` to create a new message.
 */
export const SettlementCashflowSchema: GenMessage<SettlementCashflow> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_mtm_model, 6);

/**
 * MTMIssue reports a non-fatal warning during MTM calculation.
 * Used by both CalculateMTM and CalculatePowerMTM responses.
 * An issue with a position_id means that position has no MTMPositionResult;
 * the other positions of the request are still evaluated and returned. An
 * issue without a position_id (e.g. a failure to load JEPX actual prices)
 * applies to the whole request and does not remove any result.
 *
 * @generated from message devtool.emodel.v1.MTMIssue
 */
export type MTMIssue = Message<"devtool.emodel.v1.MTMIssue"> & {
  /**
   * @generated from field: string position_id = 1;
   */
  positionId: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * Reason category of this issue.
   *
   * @generated from field: devtool.emodel.v1.MTMIssueReason reason = 3;
   */
  reason: MTMIssueReason;
};

/**
 * Describes the message devtool.emodel.v1.MTMIssue.
 * Use `create(MTMIssueSchema)` to create a new message.
 */
export const MTMIssueSchema: GenMessage<MTMIssue> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_mtm_model, 7);

/**
 * MTMIssueReason classifies why an MTM issue was reported, so that callers can
 * branch on the reason without parsing the message text.
 *
 * @generated from enum devtool.emodel.v1.MTMIssueReason
 */
export enum MTMIssueReason {
  /**
   * Not classified (e.g. reported by a server that predates this field).
   *
   * @generated from enum value: MTM_ISSUE_REASON_UNSPECIFIED = 0;
   */
  MTM_ISSUE_REASON_UNSPECIFIED = 0,

  /**
   * Curve gap: on the reference date, the forward curve has no price for a
   * period that is not yet delivered. This includes a gap in the curve of a
   * floating price index (floating_ticker).
   *
   * @generated from enum value: MTM_ISSUE_REASON_CURVE_GAP = 1;
   */
  MTM_ISSUE_REASON_CURVE_GAP = 1,

  /**
   * Any other reason than a curve gap, e.g. a failure to load JEPX actual
   * prices or confirmed market prices.
   *
   * @generated from enum value: MTM_ISSUE_REASON_OTHER = 2;
   */
  MTM_ISSUE_REASON_OTHER = 2,
}

/**
 * Describes the enum devtool.emodel.v1.MTMIssueReason.
 */
export const MTMIssueReasonSchema: GenEnum<MTMIssueReason> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_mtm_model, 0);

